<template>
  <div>
    <b-container class="modal-custom-title">
      <b-row>
        <b-col lg="12">
          <div class="text-wrapper">
            <h1>
              <strong>Neues Gesuch erfassen</strong>
              <span> | Massnahme</span>
            </h1>
            <h2></h2>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="justify-content-md-center">
        <b-col lg="6" md="12">
          <div class="link-box first">
            <property-wrapper />
          </div>
        </b-col>
        <b-col lg="6" md="12">
          <div class="link-box last">
            <advanced-wrapper />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import PropertyWrapper from '@/components/application/Intro/PropertyActions/PropertyWrapper.vue'
  import AdvancedWrapper from '@/components/application/Intro/AdvancedActions/AdvancedWrapper.vue'

  export default {
    created () {
      this.$store.commit('application/SET_MODAL_PAGE', 0)
    },
    components: {
      PropertyWrapper,
      AdvancedWrapper
    }
  }
</script>

<style lang="scss" scoped>
  #application-modal .text-wrapper{
    margin-left: 0;
  }
  .link-box::v-deep {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: white;
      padding: 25px;
      -webkit-box-shadow: 0 0 10px 0 rgba(87,87,87,0.5);
      -moz-box-shadow: 0 0 10px 0 rgba(87,87,87,0.5);
      box-shadow: 0 0 10px 0 rgba(87,87,87,0.5);
      -webkit-transition: all 1s; // 0.5
      -moz-transition: all 1s;
      transition: all 1s;
      z-index: 500;
      min-width: 225px;
      text-decoration: none;
      font-size: $font-size-lg;

      span {
          display: block;
          position: relative;
          color: $black-80;
          font-size: $font-size-lg;

          &.icon {
              display: block;
              height: 40px;
              margin-bottom: 15px;

              &.property {
                  background: assets("icon-property.svg") no-repeat top left;
                  background-size: 35px 33px;
              }

              &.other {
                  background: assets("icon-doc.svg") no-repeat top left;
                  background-size: 40px 35px;
              }
          }

          &.title {
              padding-bottom: 5px;
              margin-bottom: 5px;
              font-size: $h1-font-size;
              font-weight: $font-weight-bold;
              line-height: 1.1;
              border-bottom: 2px solid rgba(87, 87, 87, .5);

              @include media-breakpoint-down(md) {
                  br {
                      display: none;
                  }
              }
          }

          &.text {
              min-height: 100px;
              margin: 1rem 0;

              @include media-breakpoint-down(md) {
                  min-height: auto;
                  margin-bottom: 20px;
              }
          }

          &.button {
              display: block;
              text-align: center;
              padding: 9px;
              border: solid 1px $magenta;
              background: $magenta;
              color: white;
              border-radius: 4px;
          }
      }

      p{
        margin: 1rem 0;
      }

      ul{
        padding-left: 1rem;
        min-height: 120px;
      }

      &.last{
        margin-top: 0;

        @include media-breakpoint-down(md) {
           margin-top: 1rem;
        }
      }
  }
</style>
